export const OFFICIAL_USER_ID = process.env.REACT_APP_OFFICIAL_USER_ID || 'b6cl46k';

export const OFFICIAL_STUDIO_PROFILE_PATH = '/studio';
export const OFFICIAL_STUDIO_INDUSTRIES_PATH = '/studio/industries';

export const isOfficialUserId = (userId?: string | null) => String(userId || '') === OFFICIAL_USER_ID;
